import React, { useState } from 'react'
import { Box, Typography, IconButton, Grid, TextField } from '@material-ui/core'
import { ThumbsDown, ThumbsUp } from 'react-feather'

import { BaseDialog, LoadingFeedback } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import theme from 'theme'
import * as service from 'service'
import constants from 'constants/index'

const SendFeedbackModal = ({
  open = false,
  setOpen = () => {},
  onSuccess = () => {},
  daiChat = {},
}) => {
  const { TAGS } = constants.dai.solutions
  const [feedback, setFeedback] = useState('')
  const [rate, setRate] = useState(null)
  const [loading, setLoading] = useState(null)

  const snackbar = useSnackbar()

  const handleSendFeedback = async () => {
    if (!rate) return

    setLoading(true)
    try {
      await service.dponet.daiFeedbacks.create({
        daiFeedback: {
          rate,
          reason: feedback,
          externalSessionId: daiChat?.sessionId,
          daiSolutionTag: TAGS.DAI_CHAT_PLATFORM,
        },
      })

      snackbar.open({
        message: 'Feedback enviado com sucesso',
        variant: 'success',
      })
      setOpen(false)
      onSuccess()
    } catch (error) {
      snackbar.open({
        message: 'Ocorreu um erro ao enviar o feedback',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Nos ajude a melhorar nosso assistente"
      dialogSize="sm"
      fullWidth
      closeButtonText="Cancelar"
      actionButtonText="Enviar"
      actionButton={handleSendFeedback}
    >
      <LoadingFeedback open={loading} />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Typography variant="body1">O que você achou da resposta?</Typography>
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" gridGap={theme.spacing(1)}>
            <IconButton onClick={() => setRate('good')}>
              <ThumbsUp
                color={rate === 'good' ? theme.palette.primary.main : undefined}
                strokeWidth={rate === 'good' ? 2.5 : 2}
              />
            </IconButton>
            <IconButton onClick={() => setRate('bad')}>
              <ThumbsDown
                color={rate === 'bad' ? theme.palette.primary.main : undefined}
                strokeWidth={rate === 'bad' ? 2.5 : 2}
              />
            </IconButton>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">
            O que você gostaria de ver melhorado?
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            maxRows={7}
            onChange={(e) => setFeedback(e.target.value)}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

export default SendFeedbackModal
